import { StreamWSMessage } from './common';

export const CONVERSATION_START = 'conversation.start';
export const CONVERSATION_UPDATE = 'conversation.update';
export const CONVERSATION_END = 'conversation.end';
export const CONVERSATION_NEW_MESSAGE = 'conversation.new_message';
export const CONVERSATION_TRANSFER = 'conversation.transfer';
export const CONVERSATION_TRANSFER_UPDATE = 'conversation.transfer.update';

export type ConversationStatus =
  | typeof CONVERSATION_START
  | typeof CONVERSATION_UPDATE
  | typeof CONVERSATION_END
  | typeof CONVERSATION_TRANSFER;

export interface BaseConversation extends StreamWSMessage {
  type: ConversationStatus;
  body: {
    extra_info?: unknown;
    /** Not present on all conversation types (e.g. interagency_chat). */
    created_time?: number;
    source: string;
    application: string;
    /** Null for conversation types without a phone caller (e.g. interagency_chat). */
    caller_id: string | null;
    conversation_start_time: number;
    /** Null for non-PSAP conversation types (e.g. interagency_chat). */
    valid_for_psap: boolean | null;
    conversation_id: string;
  };
}
interface TCAPIConversation extends BaseConversation {
  body: BaseConversation['body'] & {
    source: 'tcapi';
    application: 'text_to_911';
    extra_info: {
      conversation_id: string;
      status: number;
    };
  };
}

interface RCSConversation extends BaseConversation {
  body: BaseConversation['body'] & {
    source: 'rcs';
    application: 'rcs_911';
    location_data: unknown;
    session_metadata: {
      conversation_id: string;
      session_id: string;
      conversation_status: number;
      authority_display_name: string;
      caller_id: string;
      authority_account_id: string;
      session_type: number;
      creation_time: number;
      last_updated_time: number;
      last_accept_time: number | null;
      expire_time: number;
    };
  };
}

export interface TCAPIConversationStart extends TCAPIConversation {
  type: typeof CONVERSATION_START;
}

export interface TTAdminConversationStart extends BaseConversation {
  type: typeof CONVERSATION_START;
  body: BaseConversation['body'] & {
    source: 'admin_sms';
    application: 'text_to_911';
  };
}

export interface RCSConversationStart extends RCSConversation {
  type: typeof CONVERSATION_START;
  body: RCSConversation['body'] & {
    location_data: {
      latitude: number;
      longitude: number;
      accuracy: number;
      location_time: string;
      source: 'rcs';
      altitude: number;
      vertical_accuracy: number;
      confidence: number;
    };
  };
}

export type ConversationStart =
  | TTAdminConversationStart
  | TCAPIConversation
  | RCSConversationStart;

export interface TCAPIConversationUpdate extends TCAPIConversation {
  type: typeof CONVERSATION_UPDATE;
}

export type ConversationUpdate = TCAPIConversationUpdate;

export interface TCAPIConversationEnd extends TCAPIConversation {
  type: typeof CONVERSATION_END;
}

export interface RCSConversationEnd extends RCSConversation {
  type: typeof CONVERSATION_END;
  body: RCSConversation['body'] & {
    location_data: undefined;
  };
}

export type ConversationEnd = TCAPIConversationEnd | RCSConversationEnd;

export type ConversationMessage =
  | ConversationStart
  | ConversationUpdate
  | ConversationEnd;
